import * as _ from 'underscore'

import { ColumnModel } from "../../modules/api/api.models"

import { LocalizationHelper } from "../../helpers"

import { Enums } from "../../models/common"
import { OpTechnicalPermission, OpData } from "../../models/core"
import { OpDataList } from "../../models/util"
import { IOpData } from "../../models/util/interfaces"

export const SERVICE_NAME = 'imrTechnicalPermissionService'

export class TechnicalPermissionService {

    //#region Ctor

    constructor() { }

    //#endregion


    //#region Public Methods

    public getTechnicalPermissionsGridColumns(): ColumnModel[] {
        const nameColumn = new ColumnModel()
        const codeColumn = new ColumnModel()

        nameColumn.idName = 'name'
        nameColumn.name = 'Name'
        nameColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name)
        nameColumn.type = Enums.DataTypeClass.Text

        codeColumn.idName = 'code'
        codeColumn.name = 'Code'
        codeColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Code)
        codeColumn.type = Enums.DataTypeClass.Text

        return [nameColumn, codeColumn]
    }

    public getTechnicalPermissionsFromDataList(dataList: OpDataList<IOpData>): OpTechnicalPermission[] {
        if (dataList != null) {
            return _.chain(dataList.toArray())
                .filter((data: IOpData) => data.idDataType === Enums.DataType.TASK_ID_TECHNICAL_PERMISSION)
                .map((data: IOpData) => {
                    const technicalPermission: OpTechnicalPermission = new OpTechnicalPermission(null);

                    technicalPermission.idTechnicalPermission = data.value
                    technicalPermission.opState = data.opState

                    return technicalPermission
                })
                .value()
        }

        return []
    }

    public getDataListFromTechnicalPermissions(technicalPermissions: OpTechnicalPermission[]): OpDataList<IOpData> {
        const dataList = new OpDataList<IOpData>()

        _.forEach(technicalPermissions, (techincalPermission: OpTechnicalPermission, index: number) => {
            dataList.setValue(techincalPermission.idTechnicalPermission, Enums.DataType.TASK_ID_TECHNICAL_PERMISSION, index)
        })

        return dataList
    }

    //#endregion


    //#region Private Methods


    //#endregion
}